export default __webpack_public_path__ + "static/media/premium.fbf82dff.svg";